import { useState, useEffect } from "react"
import { Container, Row, Col, Alert } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate, useLocation } from "react-router-dom"
import QrScanner from "./components/QrScanner"
import { getInvitationByHash } from "@/api/scanner"

const ScannerPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [error, setError] = useState<string>("")
  const [loading, setLoading] = useState(false)

  // Check for error passed via navigation state (e.g., from invalid hash redirect)
  useEffect(() => {
    if (location.state?.error) {
      setError(location.state.error as string)
      // Clear the navigation state so error doesn't persist on refresh
      navigate(location.pathname, { replace: true })
    }
  }, [location, navigate])

  const handleScan = async (hash: string, eventId: string) => {
    setError("")
    setLoading(true)
    
    try {
      console.log("🔍 Validating invitation for hash:", hash, "event_id:", eventId)
      const invitation = await getInvitationByHash(hash, eventId)
      console.log("✅ Invitation validated successfully:", invitation)
      
      // Only navigate if validation succeeds - pass guest data to avoid redundant fetch
      navigate(`/scanner/guest/${hash}?event_id=${eventId}`, {
        state: { guestData: invitation }
      })
    } catch (err: any) {
      console.error("❌ Invalid hash or error fetching invitation:", err)
      setLoading(false)
      
      // Navigate to invalid QR page for any error
      navigate("/scanner/invalid")
    }
  }

  return (
    <Container className="py-4" style={{ maxWidth: "800px" }}>
      <Row className="mb-4">
        <Col>
          <div className="text-center">
            <h1 className="h2 mb-2">{t("scanner.title")}</h1>
            <p className="text-muted small">
              {t("scanner.scanToCheckIn")}
            </p>
          </div>
        </Col>
      </Row>

      {error && (
        <Row className="mb-4">
          <Col>
            <Alert variant="danger" dismissible onClose={() => setError("")}>
              {error}
            </Alert>
          </Col>
        </Row>
      )}

      {loading && (
        <Row className="mb-4">
          <Col>
            <Alert variant="info">
              {t("scanner.loadingInvitation")}
            </Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <QrScanner onScan={handleScan} />
        </Col>
      </Row>
    </Container>
  )
}

export default ScannerPage
